<template>
  <component :is="route ? 'RouterLink' : 'a'" :class="$style.link" v-bind="linkProps">
    <IconSelect :class="$style.icon" :icon="icon" :icon-props="{ 'stroke-width': 1 }" />
    <slot />
  </component>
</template>

<script>
// import { indexOf, values } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import { typo3LinkProps } from '@/js/helper/links-helper.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

const allowedLinkTypes = {
  LINK: API_CONSTANTS.CTA.TYPES.LINK,
  DOWNLOAD: API_CONSTANTS.CTA.TYPES.DOWNLOAD,
  BACKLINK: API_CONSTANTS.CTA.TYPES.BACKLINK,
}
const defaultLinkType = allowedLinkTypes.LINK

export default {
  name: 'BaseIconLink',
  components: {
    IconSelect,
  },
  props: {
    type: {
      type: String,
      default: defaultLinkType,
    },
    href: {
      type: [String, Object],
      required: true,
    },
    route: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    link() {
      return typo3LinkProps(this.href)
    },
    linkProps() {
      return this.route
        ? {
            to: this.href,
            ...this.$attrs,
          }
        : {
            rel: 'noopener',
            href: this.link.url,
            target: this.link.target,
            title: this.link.title,
            ...this.$attrs,
          }
    },
    icon() {
      return this.type
      // const allowedLinkTypesValues = values(allowedLinkTypes)

      // if (indexOf(allowedLinkTypesValues, this.type) > 0) {
      //   return this.type
      // }

      // return defaultLinkType
    },
  },
}
</script>

<style lang="scss" module>
.link {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    margin-top: 0;
  }
  display: flex;
  align-items: center;
  margin-top: 2.5rem;

  &:hover {
    .icon {
      transform: scale(1.2);
    }
  }
}

.icon {
  // align-self: start;
  margin-right: 0.35rem;

  transition: transform var(--transition-primary);
}
</style>
